import superService from "./APIService/super.service";
import Vue from "vue";
/**
 * @param message — The message is used to display.
 * @param type — The type is used to display message with type.
 * @param duration — The duration is used for how long toasted notificatin show.
 * @returns — Pop a toasted notification.
 */
const notification = (message, type, duration) => {
  if (message !== undefined || null) {
    Vue.toasted.show(message, {
      theme: "toasted-primary",
      position: "top-right",
      duration: duration ? duration : 2000,
      type: type,
    });
  }
};

/**
 * @param name — The name is required with first name and last name.
 * @returns — A char with first name and last name first char comfin else return G.
 */
const avatarGenerator = (name) => {
  if (name != null) {
    let nfn = name.match(/\b(\w)/g);
    if (nfn !== null) return `${nfn[0] ? nfn[0] : "F"}${nfn[1] ? nfn[1] : "L"}`;
    else return "G";
  } else {
    return "G";
  }
};

const copyCode = (code, message = "") => {
  var input = document.createElement("textarea");
  input.innerHTML = code;
  document.body.appendChild(input);
  input.select();
  var result = document.execCommand("copy");
  document.body.removeChild(input);
  notification(message ? message : "Copied", "success");
  return result;
};

/**
 * @returns - Set hotels to local storage and get hotels list
 */

const hotelList = async () => {
  const hotels = [{ text: "All", value: "all" }];
  const response = await superService.getHotelsList();
  if (response) {
    response.map((item) => {
      hotels.push({ text: item.name, value: item.id });
    });
    localStorage.setItem("hotels", btoa(JSON.stringify(hotels)));
  }
  return hotels;
};

export default { notification, avatarGenerator, copyCode, hotelList };
